// Production debugging utilities for React hook issues
// Tracks hook execution for error correlation

import { useEffect } from "react";

// Simple hook to capture hook execution context without causing hydration issues
export function useProductionDebug(componentName: string) {
  useEffect(() => {
    // Only run on client-side after hydration to avoid hydration mismatch
    if (typeof window === "undefined") {
      return;
    }

    // Store hook execution log globally for error boundary access
    const windowWithHookLog = window as unknown as { __HOOK_EXECUTION_LOG__?: unknown[] };
    if (!windowWithHookLog.__HOOK_EXECUTION_LOG__) {
      windowWithHookLog.__HOOK_EXECUTION_LOG__ = [];
    }

    const hookLog = windowWithHookLog.__HOOK_EXECUTION_LOG__;

    // Add this hook execution to the log
    hookLog.push({
      component: componentName,
      hookName: "useProductionDebug",
      timestamp: Date.now(),
      route: window.location.pathname,
      stackTrace: new Error().stack, // Capture stack trace for exact location
    });

    // Keep only last 20 entries
    if (hookLog.length > 20) {
      hookLog.shift();
    }
  }, [componentName]); // Only run when component name changes
}
